import { Quill } from "@vueup/vue-quill";

const Embed = Quill.import("blots/embed");

export type FirstLineIndentValue = { width: string };

export class FirstLineIndentBlot extends Embed {
  static blotName = "firstline-indent";
  static className = "firstline-indent";
  static tagName = "span";

  static create(value: FirstLineIndentValue | string) {
    const node: HTMLElement = super.create() as HTMLElement;
    node.setAttribute("contenteditable", "false");
    node.classList.add(FirstLineIndentBlot.className);

    // Normalize value
    const width = typeof value === "string" ? value : value?.width || "2em";
    node.setAttribute("data-width", width);

    // Render as a fixed-width inline block so it behaves like a single unit
    node.style.display = "inline-block";
    node.style.width = width;
    node.style.whiteSpace = "pre";

    // Optional visual aid when selected (can be styled via CSS)
    node.innerText = "\u00A0"; // a single NBSP to ensure it has height

    return node;
  }

  static value(node: HTMLElement): FirstLineIndentValue {
    const width = node.getAttribute("data-width") || node.style.width || "2em";
    return { width };
  }
}

export default FirstLineIndentBlot;
